import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/database'

// firebase init
const firebaseConfig = {
  apiKey: "AIzaSyBXOZzaNaQDu9P97P7uGFyu3lXuPAWYmF8",
  appId: "1:58809287856:web:77f5dbd18b5049adba2775",
  authDomain: "hubday-8f81c.firebaseapp.com",
  databaseURL: "https://hubday-8f81c.firebaseio.com",
  measurementId: "G-D8WPJWT0BJ",
  messagingSenderId: "58809287856",
  projectId: "hubday-8f81c",
  storageBucket: "hubday-8f81c.appspot.com"
}
firebase.initializeApp(firebaseConfig)

// utils
//const /db = firebase.firestore()
const auth = firebase.auth()
const functions = firebase.app().functions('europe-west3');
const rtdb = firebase.database();

// collection references
//const usersCollection = db.collection('users')
//const postsCollection = db.collection('posts')
//const commentsCollection = db.collection('comments')
//const likesCollection = db.collection('likes')

const oldModulesRef = rtdb.ref("modulesOld");
const modulesRef = rtdb.ref("modules");
var agendaRef = null;

// export utils/refs
export {
  //db,
  rtdb,
  auth,
  functions,
  //usersCollection,
  //postsCollection,
  //commentsCollection,
  //likesCollection,
  oldModulesRef,
  modulesRef,
  agendaRef
}
